import { handleActions } from 'redux-actions';
import * as Actions from '../../actions';

const initialState = {
	data: null,
	generatedSecret: null
};

const clientReducer = handleActions(
	{
		[Actions.fetchClientSuccess]: (state, action) => {
			return {
				...state,
				data: action.payload
			};
		},
		[Actions.createClientSuccess]: (state, action) => {
			return {
				...state,
				data: action.payload
			};
		},
		[Actions.updateClientSuccess]: (state, action) => {
			return {
				...state,
				data: action.payload
			};
		},
		[Actions.deleteClientSuccess]: state => {
			return {
				...state,
				data: null
			};
		},
		[Actions.createClientSecretSuccess]: (state, action) => {
			const {description, type, expiration, value, secret } = action.payload.data;
			return {
				...state,
				data: {...state.data, clientSecrets: [...state.data.clientSecrets, {description, type, expiration, value}]},
				generatedSecret: secret
			}
		},
		[Actions.acceptClientSecret]: state => {
			return {
				...state,
				generatedSecret: null
			}
		}
	},
	initialState
);

export default clientReducer;
